import { View } from 'react-native';
import { fasPlusCircle } from 'shared/@generated/icons/fasPlusCircle';
import { Icon } from 'shared/components/icon';
import { BreedPrice, Paper, type ExampleBreedKey } from './discovery-parts';
import {
  Caption,
  CroppedPhone,
  IllustrationFrame,
  Photo,
  type IllustrationProps,
  type PhotoTone,
  useIllustrationCopy,
} from './illustration-parts';
import { illustrationPalette as palette } from './illustration-palette';
import type { IllustrationScale } from './illustration-scene';

function ExistingListingRow({
  s,
  tone,
  breedKey,
}: {
  s: IllustrationScale;
  tone: PhotoTone;
  breedKey: ExampleBreedKey;
}) {
  return (
    <View
      className="flex-row items-center"
      style={{
        width: s(92),
        height: s(32),
        gap: s(5),
        borderBottomWidth: s(0.4),
        borderColor: palette.ink + '20',
      }}
    >
      <Photo s={s} width={27} height={26} tone={tone} />
      <View className="flex-1">
        <BreedPrice s={s} size={7} breedKey={breedKey} />
      </View>
    </View>
  );
}

export function PublishListing({ transparent = false }: IllustrationProps) {
  const t = useIllustrationCopy();
  return (
    <IllustrationFrame transparent={transparent}>
      {(s) => (
        <>
          <CroppedPhone s={s} width={116} y={10}>
            <View style={{ gap: s(8) }}>
              <Caption s={s} size={8}>
                {t('listings')}
              </Caption>
              <ExistingListingRow s={s} tone="clay" breedKey="breed_labrador" />
              <View
                style={{
                  width: s(92),
                  height: s(30),
                  borderWidth: s(0.7),
                  borderColor: palette.ink + '25',
                  borderStyle: 'dashed',
                  borderRadius: s(3),
                  backgroundColor: palette.sageLight,
                }}
              />
              <ExistingListingRow s={s} tone="olive" breedKey="breed_ragdoll" />
              <ExistingListingRow s={s} tone="cream" breedKey="breed_poodle" />
            </View>
          </CroppedPhone>
          <Paper s={s} x={14} y={83} width={132} height={43} angle={-3} padding={4}>
            <View className="flex-row items-center" style={{ gap: s(8) }}>
              <Photo s={s} width={33} height={33} />
              <View className="flex-1">
                <BreedPrice s={s} size={8} />
              </View>
              <Icon
                icon={fasPlusCircle}
                className="text-brand-green-dark"
                style={{ width: s(12), height: s(12) }}
              />
            </View>
          </Paper>
        </>
      )}
    </IllustrationFrame>
  );
}
